import { takeEvery, call, select, put } from 'redux-saga/effects';
import { getAccountToken } from '../selectors';
import {showMessage, FILE_DOWNLOAD_REQUEST} from '../actions'
import {getApiUrl} from '../config'
import last from 'lodash/last'
import {saveAs} from 'file-saver'

function* callFileDownload(action) {
    try {
        const token = yield select(getAccountToken);

        var headers = {
            'Authorization': 'Bearer ' + token,
            'Accept': '*.*',
        };

        const fetchOptions = {
            method: 'GET',
            headers: headers,
        };

        const response = yield call(fetch, `${getApiUrl()}api/file?url=${encodeURIComponent(action.payload.url.split('/').slice(3).join('/'))}`, fetchOptions);

        if (response.status >= 200 && response.status < 300)
        {
            const blob = yield response.blob();
            saveAs(blob, last(action.payload.url.split('/')))
        }
        else {
            yield put(showMessage('error', `Download error: ${response.status}`))
        }

    } catch (e) {
        yield put(showMessage('error', e.message))
    }
}

export default function* fileDownloadSaga() {
    yield takeEvery(FILE_DOWNLOAD_REQUEST, callFileDownload);

};


// WEBPACK FOOTER //
// ./src/saga/fileDownloadSaga.js